import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CreateSiteModule } from './create-site/create-site.module';
import { AutoCompleteModule } from './autoComplete/autoComplete.module';
import { ChipsInputModule } from './chipsInput/chipsInput.module';
import { MainPipe } from './pipes/pipes.module';
import { PortalLinkTileModule } from './portalLinkTile/portalLinkTile.module';
import { AppMaterialModule } from './appMaterial/app-material.module';
import { EnrollEmailDuplicateModule } from './enrollEmailDuplicate/enroll-email-duplicate.module';
import { EqualValidatorModule } from './equalValidator/equal-validator.module';
import { ChickenTestModule } from './chickenTest/chicken-test.module';
import { MinDirectiveModule } from './minValidator/minDirective.module';
import { MaxDirectiveModule } from './maxValidator/maxDirective.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ChipsLegendInputModule } from './chipsLegendInput/chipsLegendInput.module';
import { PasswordValidatorModule } from './passwordValidator/passwordValidator.module';
import { TermsModule } from './terms/terms.module';
import { ConfirmPasswordModule } from './confirm-password-validator/confirm-password.module';
import { AccordionAnchorDirective, AccordionDirective, AccordionLinkDirective } from './accordion';
import { FilterPipe } from './pipes/filter.pipe';
import { TimezoneModule } from './timezone/timezone.module';
import { EditEmailDuplicateModule } from './editEmailDuplicate/edit-email-duplicate.module';
import { AccountAlertModule } from './account-alert/account-alert.module';
import { PhonePurchaseErrorModule } from './phone-purchase-error/phone-purchase-error.module';
import { TriggerDuplicateModule } from './triggerDuplicate/trigger-duplicate.module';
import { CloneTriggerModule } from './clone-trigger/clone-trigger.module';
import { AsyncButtonDirectiveModule } from './async-button/async-button.module';
import {DragDropModule} from "./drag-drop/drag-drop.module";
import {FileUploaderModule} from "./file-uploader/file-uploader.module";

/**
 * Do not specify providers for modules that might be imported by a lazy loaded module.
 */

import { NgxMaskModule, IConfig } from 'ngx-mask';
import { SiglaAccFormControlModule } from './sigla-acc-form-control/sigla-acc-form-control.module';
import {AgGridComponentsModule} from "./ag-grid-components/ag-grid-components.module";
import { MultiRecipientEmailInputModule } from './multi-recipient-email-input/multi-recipient-email-input.module';
import { NumbersOnlyDirectiveModule } from './numbersOnlyValidator/numbersOnlyDirective.module';
import { LookerListItemComponent } from './looker-list-item/looker-list-item.component';

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        AppMaterialModule,
        AutoCompleteModule,
        ChipsInputModule,
        ChipsLegendInputModule,
        MainPipe,
        EqualValidatorModule,
        MinDirectiveModule,
        MaxDirectiveModule,
        PasswordValidatorModule,
        FlexLayoutModule.withConfig({useColumnBasisZero: false}),
        FormsModule,
        ReactiveFormsModule,
        TimezoneModule,
        NgxMaskModule.forRoot(),
        AsyncButtonDirectiveModule,
        DragDropModule,
        FileUploaderModule,
        NumbersOnlyDirectiveModule
    ],
  declarations: [AccordionAnchorDirective, AccordionLinkDirective, AccordionDirective, FilterPipe, LookerListItemComponent],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    AutoCompleteModule,
    ChipsInputModule,
    ChipsLegendInputModule,
    MainPipe,
    PortalLinkTileModule,
    EnrollEmailDuplicateModule,
    EditEmailDuplicateModule,
    EqualValidatorModule,
    ChickenTestModule,
    CloneTriggerModule,
    CreateSiteModule,
    MaxDirectiveModule,
    MinDirectiveModule,
    PasswordValidatorModule,
    ConfirmPasswordModule,
    TermsModule,
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    AppMaterialModule,
    FilterPipe,
    TimezoneModule,
    AccountAlertModule,
    PhonePurchaseErrorModule,
    TriggerDuplicateModule,
    AsyncButtonDirectiveModule,
    FileUploaderModule,
    SiglaAccFormControlModule,
    AgGridComponentsModule,
    MultiRecipientEmailInputModule,
    LookerListItemComponent
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: []
    };
  }
}
